import gql from 'graphql-tag'

const insertDelegation = delegation => ({
	mutation: gql`
		mutation ($delegation: organizations_delegations_insert_input!) {
			insert_organizations_delegations_one(object: $delegation) {
				id
			}
		}
	`,
	variables: { delegation }
})

export { insertDelegation }
